export interface AlertResponse {
  alerts: Alert[]
  totalPages: number
}

export interface AlertReportResponse {
  statusCode: number
  message: string
  download_url?: string
}

export interface Alert {
  id: number
  alertName: string
  scanTime: string
  createdAt: string
  updatedAt: string
  scanMethod: ScanMethod
  severity: Severity
  alertStatus: AlertStatus
  scannedByAccessCode: string
  alertDescription: string
  scanId: string
  device: string
  memberName: string
  platform: string
  osVersion: string
  alertType: AlertType
  scannedBy?: string
  demoAlert?: boolean
}

export interface ResolveAlert {
  alertId: number
  scanId: string
  alertName?: string
  alertType?: AlertType
}

export enum Severity {
  CRITICAL = 'CRITICAL',
  HIGH = 'HIGH',
  SUSPICIOUS = 'SUSPICIOUS',
  LOW = 'LOW',
}

export enum AlertStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}

export enum AlertType {
  DEVICE_SCAN = 'DEVICE_SCAN',
  TRAVEL = 'TRAVEL',
}

export enum ScanMethod {
  EDR_APP = 'EDR',
  IVY_APP = 'IVY_APP',
  THREAT_HUNTER = 'THREAT_HUNTER',
  APP_SYSDIAGNOSE = 'APP_SYSDIAGNOSE',
  APP_BUG_REPORT = 'APP_BUG_REPORT',
  IVERIFY_ELITE = 'IVERIFY_ELITE',
}

export enum AlertSimType {
  PEGASUS = "Pegasus Spyware",
  PREDATOR = "Predator Spyware",
  PRIVILEGE_ESCALATION = "System Privilege Escalation",
  MALICIOUS_APK = "Malicious APK Discovered",
  DEVICE_ROOTED = "Device Rooted",
  BOOTLOAD_VALIDATION = "Bootload Validation"
}